import React, { Component } from "react";

import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";

import { TextField, Loadable, StyledButton } from "components/support";

import { brands } from "assets";

import style from "./style";

class PasswordRecoveryView extends Component {
  constructor(props) {
    super(props);

    this.presenter = props.presenter;

    this.state = {
      password: "",
      confirmPassword: ""
    };
  }

  handleChange = field => event => {
    const stateChange = {};
    stateChange[field] = event.target.value;
    this.setState(stateChange);
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.presenter.onFormSubmit(
      this.state.password,
      this.state.confirmPassword
    );
  };

  render() {
    const { viewModel, className } = this.props;
    const { loading, form } = viewModel;

    return (
      <div
        id="password-recovery"
        className={`${className} layout-full-height grid-container`}
      >
        <Row className="layout-full-height" middle="xs">
          <Col xs={12}>
            <div className="text-center">
              <img
                src={brands.png.primary}
                height="80"
                alt="PDVend"
                className="pdvend-logo"
                style={{ marginBottom: 20 }}
              />
            </div>
            <Row center="xs">
              <Col xs={12} sm={9} md={5} lg={4}>
                <Paper elevation={1}>
                  <Loadable loading={loading}>
                    <Typography type="headline">
                      Informe sua nova senha
                    </Typography>
                    <form id="passwordrecovery" onSubmit={this.handleSubmit}>
                      <Col xs={12}>
                        <TextField
                          fullWidth
                          label="Senha para acessar a PDVend"
                          type="password"
                          required={true}
                          disabled={loading}
                          value={this.state.password}
                          onChange={this.handleChange("password")}
                          errorText={form.errors.password || ""}
                        />
                      </Col>
                      <Col xs={12}>
                        <TextField
                          fullWidth
                          label="Confirme sua Senha"
                          type="password"
                          required={true}
                          disabled={loading}
                          value={this.state.confirmPassword}
                          onChange={this.handleChange("confirmPassword")}
                          errorText={form.errors.confirmPassword || ""}
                        />
                      </Col>
                      <div className="p-sm">
                        <StyledButton
                          primary
                          style={{ marginTop: 4 }}
                          type="submit"
                          disabled={loading}
                        >
                          Enviar
                        </StyledButton>
                      </div>
                    </form>
                  </Loadable>
                </Paper>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}
export default style(PasswordRecoveryView);



// WEBPACK FOOTER //
// ./src/components/app/password-recovery/view.jsx